type LenisLike = { stop?: () => void; start?: () => void };

export class DrawerController {
    private static toggle: HTMLElement | null = null;
    private static drawer: HTMLElement | null = null;

    static init(): void {
        this.toggle = document.querySelector<HTMLElement>(".site-header__menu-toggle");
        this.drawer = document.querySelector<HTMLElement>("#main-drawer");
        if (!this.toggle || !this.drawer) return;

        // The closed off-canvas drawer must be removed from sequential focus.
        // Markup also carries `inert` so the contract holds before JS starts.
        this.drawer.inert = this.drawer.dataset.state !== "open";

        const closeBtn = this.drawer.querySelector<HTMLElement>(".site-drawer__close");

        this.toggle.addEventListener("click", () => {
            this.set(this.drawer?.dataset.state !== "open");
        });

        closeBtn?.addEventListener("click", () => this.set(false));

        // Accordion sub-menu toggles
        this.drawer.querySelectorAll<HTMLButtonElement>(".site-drawer__toggle").forEach((btn) => {
            btn.addEventListener("click", () => {
                const item = btn.closest<HTMLElement>(".site-drawer__nav-item");
                if (!item) return;
                const isOpen = item.classList.contains("is-expanded");
                // Close all others
                this.drawer?.querySelectorAll<HTMLElement>(".site-drawer__nav-item.is-expanded").forEach((el) => {
                    el.classList.remove("is-expanded");
                    el.querySelector<HTMLButtonElement>(".site-drawer__toggle")?.setAttribute("aria-expanded", "false");
                });
                if (!isOpen) {
                    item.classList.add("is-expanded");
                    btn.setAttribute("aria-expanded", "true");
                }
            });
        });

        // Close on link click
        this.drawer.querySelectorAll<HTMLAnchorElement>(".site-drawer__sub-link").forEach((link) => {
            link.addEventListener("click", () => this.set(false));
        });
        this.drawer.querySelectorAll<HTMLAnchorElement>(".site-drawer__nav-label").forEach((link) => {
            link.addEventListener("click", (event) => {
                const item = link.closest<HTMLElement>(".site-drawer__nav-item");
                if (item?.classList.contains("has-children")) {
                    event.preventDefault();
                    item.querySelector<HTMLButtonElement>(".site-drawer__toggle")?.click();
                    return;
                }
                this.set(false);
            });
        });

        document.addEventListener("keydown", (event) => {
            if (event.key === "Escape") this.set(false);
        });

        window.addEventListener("resize", () => {
            if (window.innerWidth > 768 && this.drawer?.dataset.state === "open") {
                this.set(false);
            }
        });
    }

    private static set(open: boolean): void {
        if (!this.drawer || !this.toggle) return;

        const icon = this.toggle.querySelector<HTMLElement>("i");

        this.drawer.dataset.state = open ? "open" : "closed";
        this.drawer.setAttribute("aria-hidden", open ? "false" : "true");
        this.drawer.inert = !open;
        this.toggle.setAttribute("aria-expanded", open ? "true" : "false");
        this.toggle.classList.toggle("is-open", open);
        document.documentElement.classList.toggle("is-drawer-open", open);

        if (icon) {
            icon.className = open ? "fa-regular fa-xmark" : "fa-regular fa-bars";
        }

        const lenis = (window as unknown as { lenis?: LenisLike }).lenis;
        if (open) {
            lenis?.stop?.();
            window.requestAnimationFrame(() => {
                this.drawer?.querySelector<HTMLElement>(".site-drawer__close")?.focus({ preventScroll: true });
            });
        } else {
            lenis?.start?.();
            if (this.drawer.contains(document.activeElement)) {
                this.toggle.focus({ preventScroll: true });
            }
        }
    }
}
